// External URLs
export const EXTERNAL_URLS = {
  RAM_MANDIR: {
    BOOKING: 'https://online.srjbtkshetra.org/#/mobileVerification',
    LIVE_AARTI: 'https://www.youtube.com/watch?v=U7Omsf9bJQA&list=PLUiMfS6qzIMwrtdJGFdP2BMN9S-0VaDKS&t=90',
    LIVE_AARTI_THUMBNAIL: 'https://img.youtube.com/vi/U7Omsf9bJQA/maxresdefault.jpg'
  },
  SUGAM_DARSHAN: {
    BOOKING: 'https://online.srjbtkshetra.org/#/mobileVerification'
  }
};

// Internal Routes
export const ROUTES = {
  HOME: '/',
  TEMPLES: '/temples',
  AARTI: '/aarti',
  HOTELS: '/hotels',
  GALLERY: '/gallery',
  CONTACT: '/contact',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  DARSHAN_BOOKING: '/darshan-booking'
};
